import React, { createContext, useContext, useEffect, useState } from "react";

const FeaturesContext = createContext({});

const FeaturesProvider = ({ isOpen, children }) => {
  const [features, setFeatures] = useState(() => ({
    hideEndTime: !!window.propDMNHideEndTime,
  }));

  useEffect(() => {
    if (isOpen) {
      setFeatures({ hideEndTime: !!window.propDMNHideEndTime });
    }
  }, [isOpen]);

  return (
    <FeaturesContext.Provider value={features}>
      {children}
    </FeaturesContext.Provider>
  );
};

const useFeatures = () => useContext(FeaturesContext);

export { FeaturesContext, FeaturesProvider, useFeatures };
